export default __webpack_public_path__ + "static/media/craon2.3e02677d.jpg";